// @flow
import orderService from "../../order/api/orderService";
import productService from "../../service/productService";
import mailService from "../../service/mailService";
import navigationUpdateOrderService from "../service/navigationUpdateOrderService";
import i18n from "../../i18n/i18n";

export const NAVIGATION_UPDATE_ORDER = {
	REQUEST: "NAVIGATION_UPDATE_ORDER_REQUEST",
	SUCCESS: "NAVIGATION_UPDATE_ORDER_SUCCESS",
	FAILURE: "NAVIGATION_UPDATE_ORDER_FAILURE",
	MAIL_FAILURE: "NAVIGATION_UPDATE_ORDER_MAIL_FAILURE",
	VIN_BLOCKED: "NAVIGATION_UPDATE_ORDER_VIN_BLOCKED"
};

export const submitNavigationUpdateOrder = (vin: string, requestCode: string, partNumber: string) => {
	return async dispatch => {
		dispatch({type: NAVIGATION_UPDATE_ORDER.REQUEST});
		try {
			const isAvailable = await navigationUpdateOrderService.isVinAvailable(vin);
			if (!isAvailable) {
				dispatch({type: NAVIGATION_UPDATE_ORDER.VIN_BLOCKED});
				return;
			}

			const detailedProducts = await productService.getDetailedProducts(
				[partNumber],
				false,
				true,
				false
			);
			const productDetail = detailedProducts[0]?.detail;
			const price = productDetail?.storage?.stockOrderPrice?.value;
			if (price == null) {
				throw new Error(i18n.t("navigationUpdate.errors.priceNotFound"));
			}

			const orderName = i18n.t("navigationUpdate.title");
			const order = {
				orderName,
				salesPromotionId: 0,
				orderTypeId: 46,
				orderItems: [
					{
						partNumber: partNumber,
						quantity: 1,
						price: price,
						note: ""
					}
				]
			};

			const response = await orderService.createOrder(order);
			const orderNumber = response.data.orderId;
			await orderService.placeOrder(orderNumber);

			await navigationUpdateOrderService.saveOrder(vin, requestCode, orderNumber);

			dispatch({
				type: NAVIGATION_UPDATE_ORDER.SUCCESS,
				orderNumber
			});

			try {
				await mailService.sendNavigationUpdateOrderMail(vin, requestCode, orderNumber);
			} catch (mailError) {
				dispatch({
					type: NAVIGATION_UPDATE_ORDER.MAIL_FAILURE,
					error: mailError
				});
			}
		} catch (error) {
			dispatch({
				type: NAVIGATION_UPDATE_ORDER.FAILURE,
				error
			});
		}
	};
};
